import { PURGE } from "redux-persist";
import { pushEmailClientSI, pushEmailCompanySI, pushEmailSIAll } from "../actions/taskAction";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: 'idle',
    hasError: false,
    errorMessage: '',
    data: [],
}

const taskSlice = createSlice({
    name: 'task',
    initialState,
    reducers: {
            resetState: () => {
                return initialState;
            }
    
        },
        extraReducers: (builder) => {
            builder.addCase(PURGE, () => {
                return initialState;
            })
                .addCase(pushEmailClientSI.pending, (state) => {
                    state.loading = 'pending';
                    state.hasError = false
                    state.errorMessage = '';
                    state.data = [] ;
                })
                .addCase(pushEmailClientSI.fulfilled, (state, action) => {
                    state.loading = 'succeeded';
                    state.hasError = false;
                    state.data = action.payload;
                    state.errorMessage = "";
                })

                .addCase(pushEmailClientSI.rejected, (state, action) => {
                    state.loading = 'failed';
                    state.hasError = true;
                    state.errorMessage = action.payload
                    state.data = [];
                })

                .addCase(pushEmailCompanySI.pending, (state) => {
                    state.loading = 'pending';
                    state.hasError = false
                    state.errorMessage = '';
                    state.data = [] ;
                })
                .addCase(pushEmailCompanySI.fulfilled, (state, action) => {
                    state.loading = 'succeeded';
                    state.hasError = false;
                    state.data = action.payload;
                    state.errorMessage = "";
                })

                .addCase(pushEmailCompanySI.rejected, (state, action) => {
                    state.loading = 'failed';
                    state.hasError = true;
                    state.errorMessage = action.payload
                    state.data = [];
                })
                .addCase(pushEmailSIAll.pending, (state) => {
                    state.loading = 'pending';
                    state.hasError = false
                    state.errorMessage = '';
                    state.data = [] ;
                })
                .addCase(pushEmailSIAll.fulfilled, (state, action) => {
                    state.loading = 'succeeded';
                    state.hasError = false;
                    state.data = action.payload;
                    state.errorMessage = "";
                })
                .addCase(pushEmailSIAll.rejected, (state, action) => {
                    state.loading = 'failed';
                    state.hasError = true;
                    state.errorMessage = action.payload
                    state.data = [];
                })
        }
});

export const { resetState } = taskSlice.actions;

export default taskSlice.reducer;